export default __webpack_public_path__ + "static/media/Receive-Invitations-img.62701c37.jpg";